/**
 * contains the abi and contract address
*/

class DMCAContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "reasoningHash",
				"type": "bytes32"
			}
		],
		"name": "copyStrikeSample",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "address",
				"name": "newDesignatedAgent",
				"type": "address"
			}
		],
		"name": "switchDesignatedAgent",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			}
		],
		"name": "takedownSample",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "reasoningHash",
				"type": "bytes32"
			}
		],
		"name": "SampleCopyStrike",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			}
		],
		"name": "SampleTakenDown",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "agent",
				"type": "address"
			}
		],
		"name": "NewDesignatedAgent",
		"type": "event"
	}
        ];

        this.contractAddress = '0xAd4752a6C01C2B25b6248bEB33B1B03f2BE9F9E7';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default DMCAContract;
